import React from 'react'

const Layout = ({ children }) => {
    return (
        <>
            <div className='layout-bg'>
                {children}
            </div>
        </>
    )
}

export default Layout